import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card card-flush py-4 mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder fs-6 text-gray-600 text-uppercase m-0" }, "Phụ trách")
], -1)
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Chọn loại:", -1)
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5" }
const _hoisted_8 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5" }
const _hoisted_9 = {
  key: 0,
  class: "mt-3 w-100 mb-5"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Người phụ trách", -1)
const _hoisted_11 = {
  key: 1,
  class: "mt-3 mb-5 fv-row w-100"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Nhóm phụ trách", -1)
const _hoisted_13 = { class: "fv-row w-100 text-end d-flex justify-content-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, [
            _createVNode(_component_el_checkbox, {
              disabled: !_ctx.isEdit,
              class: "",
              modelValue: _ctx.typeOption,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.typeOption) = $event)),
              onChange: _ctx.changeOption,
              value: 1,
              label: 1
            }, {
              default: _withCtx(() => [
                _createTextVNode("Người phụ trách")
              ]),
              _: 1
            }, 8, ["disabled", "modelValue", "onChange"])
          ]),
          _createElementVNode("label", _hoisted_8, [
            _createVNode(_component_el_checkbox, {
              disabled: !_ctx.isEdit,
              class: "",
              modelValue: _ctx.typeOption1,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.typeOption1) = $event)),
              onChange: _ctx.changeOption1,
              value: 2,
              label: 2
            }, {
              default: _withCtx(() => [
                _createTextVNode("Nhóm phụ trách")
              ]),
              _: 1
            }, 8, ["disabled", "modelValue", "onChange"])
          ])
        ])
      ]),
      (_ctx.typeOption)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_select, {
              class: "form-select-solid w-100",
              placeholder: "Chọn người phụ trách",
              modelValue: _ctx.assign,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.assign) = $event)),
              ref: "statusGraduated",
              disabled: !_ctx.isEdit,
              filterable: true
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrUsers, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.fullName+'/'+item.email,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.typeOption1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_el_select, {
              class: "form-select-solid w-100",
              placeholder: "Chọn nhóm phụ trách",
              modelValue: _ctx.assignGroup,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.assignGroup) = $event)),
              ref: "statusGraduated",
              disabled: !_ctx.isEdit,
              filterable: true
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrGroups, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.groupName+'/'+item.groupCode,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        (_ctx.isEdit)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "btn btn-secondary min-w-100px umt-btn-32",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.defaultData && _ctx.defaultData(...args)))
            }, "Trở lại"))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: "btn btn-primary min-w-100px umt-btn-32",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeEdit && _ctx.changeEdit(...args)))
        }, _toDisplayString(_ctx.isEdit ? "Lưu" : "Thay đổi"), 1)
      ])
    ])
  ]))
}